export default __webpack_public_path__ + "static/media/Rob-Walch.93bf50b7.jpg";